import ResizeObserver from 'resize-observer-polyfill'

window.ResizeObserver = window.ResizeObserver || ResizeObserver
